module.exports = __webpack_public_path__ + "static/media/DSC_0006.7018309f.jpg";